enum RecipientsRecipientInfoActionType {
    RECIPIENTS_RECIPIENT_INFO_LOAD_COUNTRIES = "RECIPIENTS_RECIPIENT_INFO_LOAD_COUNTRIES",
    RECIPIENTS_RECIPIENT_INFO_LOAD_REQUIREMENTS = "RECIPIENTS_RECIPIENT_INFO_LOAD_REQUIREMENTS",
    RECIPIENTS_RECIPIENT_INFO_SAVE_LAST_POSTED_RECIPIENT_ID = "RECIPIENTS_RECIPIENT_INFO_SAVE_LAST_POSTED_RECIPIENT_ID",
}

export default RecipientsRecipientInfoActionType;